export const entityBrowserConstants = {
    FETCH_SELECTED_NODE_ID_REQUEST: 'FETCH_SELECTED_NODE_ID_REQUEST',
    FETCH_SELECTED_NODE_ID_SUCCESS: 'FETCH_SELECTED_NODE_ID_SUCCESS',
    FETCH_SELECTED_NODE_ID_FAILURE: 'FETCH_SELECTED_NODE_ID_FAILURE',

    FETCH_EXPANDED_NODE_ID_REQUEST: 'FETCH_EXPANDED_NODE_ID_REQUEST',
    FETCH_EXPANDED_NODE_ID_SUCCESS: 'FETCH_EXPANDED_NODE_ID_SUCCESS',
    FETCH_EXPANDED_NODE_ID_FAILURE: 'FETCH_EXPANDED_NODE_ID_FAILURE',

    UPDATE_SELECTED_NODE_ID_REQUEST: 'UPDATE_SELECTED_NODE_ID_REQUEST',
    UPDATE_SELECTED_NODE_ID_SUCCESS: 'UPDATE_SELECTED_NODE_ID_SUCCESS',
    UPDATE_SELECTED_NODE_ID_FAILURE: 'UPDATE_SELECTED_NODE_ID_FAILURE',

    UPDATE_EXPANDED_NODE_ID_REQUEST: 'UPDATE_EXPANDED_NODE_ID_REQUEST',
    UPDATE_EXPANDED_NODE_ID_SUCCESS: 'UPDATE_EXPANDED_NODE_ID_SUCCESS',
    UPDATE_EXPANDED_NODE_ID_FAIURE: 'UPDATE_EXPANDED_NODE_ID_FAILURE',
};
